import {store} from 'App/store';
import _ from 'lodash';
import {findDOMNode} from 'react-dom';
import {getErrorTexts} from '../ebayListingSelectors';
import {TweenLite} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import {getAttentionAnimation} from 'shared/helpers/animationHelper';
import CollapsingWrapper from 'shared/components/CollapsingWrapper/CollapsingWrapper';
import {setOpenSectionIndex} from 'MyAccount/ViewDesigns/redux/modules/ebayListing';
import {adjustLocationInStore} from 'shared/components/redux/connectWithRouter';

/* global Strong Linear SlowMo Ease TimelineMax */
const refs = {};
export function setRef(fieldName, ref) {
  refs[fieldName] = ref;
}

export const getTopMostField = _.memoize(fieldNames => {
  const fieldsWithRefs = _.filter(
    _.map(fieldNames, fieldName => {
      const ref = refs[fieldName];
      if (fieldName && ref) {
        const {top} = findDOMNode(ref).getBoundingClientRect();
        const {sectionIndex} = ref.context;
        return {top, fieldName, sectionIndex};
      }
    })
  );
  const fieldsBySection = _.groupBy(fieldsWithRefs, 'sectionIndex');
  return _.head(_.sortBy(_.values(fieldsBySection)[0], 'top'));
});

export function getTopMostFieldWithError() {
  const errorTexts = getErrorTexts(adjustLocationInStore(store.getState()));
  const topMostFieldWithError = getTopMostField(_.keys(errorTexts));
  if (!topMostFieldWithError) {
    console.warn('There is a hidden field with error', errorTexts);
  }
  return topMostFieldWithError;
}
export function scrollToField(fieldName) {
  const ref = refs[fieldName];
  if (ref && ref.context && _.isNumber(ref.context.sectionIndex) && ref.context.getScrollableContainer) {
    const sectionIndex = ref.context.sectionIndex;
    let animationDelay;
    if (store.getState().ebayListing.openSectionIndex === sectionIndex) {
      animationDelay = 0;
    } else {
      store.dispatch(setOpenSectionIndex(sectionIndex));
      animationDelay = CollapsingWrapper.defaultTransitionDuration + 30;
    }
    _.delay(() => {
      const fieldDomNode = findDOMNode(ref);
      const fieldTop = fieldDomNode.offsetTop;
      let desiredOffset = fieldTop - 50;
      const scrollableContainer = ref.context.getScrollableContainer();
      const maxDesiredOffset = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
      if (maxDesiredOffset < desiredOffset) {
        desiredOffset = maxDesiredOffset;
      }
      if (Math.abs(scrollableContainer.scrollTop - desiredOffset) <= 50) {
        getAttentionAnimation(fieldDomNode, 'x', -1);
      }
      TweenLite.to(scrollableContainer, 0.25, {scrollTo: {y: desiredOffset}, ease: Ease.easeInOut});
    }, animationDelay);
  }
}

export function scrollToTopMostFieldWithError() {
  const topMostFieldWithError = getTopMostFieldWithError();
  if (topMostFieldWithError) {
    scrollToField(topMostFieldWithError.fieldName);
  }
}

window.scrollToField = scrollToField;
